import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Box from "@mui/material/Box";
/**
 * @todo Figure out how to handle this in production. Translate
 * @param props
 * @returns
 */
export function AttributeErrorView(props) {
    return (_jsx(Box, { sx: {
            my: 2,
        }, children: _jsxs(Alert, { severity: "error", children: [_jsxs(AlertTitle, { children: ["Component Error ", props.attribute.id] }), "The component for caused an error and cannot be displayed", _jsxs("details", { children: [_jsx("summary", { children: props.error.message }), _jsx("code", { children: props.error.stack })] })] }) }));
}
//# sourceMappingURL=AttributeErrorView.js.map